import React, { useState, useContext } from "react";
import {BrowserRouter, Route, Router, Routes, Navigate } from 'react-router-dom';
import "./styles/App.css";
import { Search } from "./pages/search"
import { ErrorPage } from "./pages/errorPage"
import { Ad } from "./pages/ad";
import { Batch } from "./pages/batch";
import { Home } from "./pages/home";
import { Batches } from "./pages/batches";
import { AdUpload } from "./pages/adUpload";
import { SampleAnalyses } from "./pages/sampleAnalyses";
import { About } from "./pages/about";
import { Contact } from "./pages/contact";
import { Analytics } from "./pages/analytics";
import { Login } from "./pages/login";
import { AuthProvider, AuthContext } from "./components/AuthContext";

/*<Route exact path="/register" render={() => ( <Redirect to="/dashboard"/>)*/

function RequireAuth({ children }) {
  const { authenticated } = useContext(AuthContext);

  return authenticated ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <AuthProvider>
    <Routes>
      <Route path="/" element={<RequireAuth><Home/></RequireAuth>} />
      <Route path="login" element={<Login/>} />
      <Route path="about" element={<RequireAuth><About/></RequireAuth>}  />
      <Route path="contact" element={<RequireAuth><Contact/></RequireAuth>}  />
      <Route path="search" element={<RequireAuth><Search/></RequireAuth>} />
      <Route path="ad/:adId" element={<RequireAuth><Ad/></RequireAuth>} />
      <Route path="batch/:batchId" element={<RequireAuth><Batch/></RequireAuth>} />
      <Route path="batches" element={<RequireAuth><Batches/></RequireAuth>} />
      <Route path="contribute" element={<RequireAuth><AdUpload/></RequireAuth>} />
      <Route path="samples" element={<RequireAuth><SampleAnalyses/></RequireAuth>} />
      <Route path="analytics" element={<RequireAuth><Analytics/></RequireAuth>} />
      <Route path="*" element={<ErrorPage/>} />
    </Routes>
   </AuthProvider>
  );
}
export default App;
